import { render, staticRenderFns } from "./v4_mobile.vue?vue&type=template&id=bbdae194&scoped=true&"
import script from "./v4_mobile.vue?vue&type=script&lang=js&"
export * from "./v4_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v4_mobile.vue?vue&type=style&index=0&id=bbdae194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdae194",
  null
  
)

export default component.exports